export default __webpack_public_path__ + "static/automotive8-7f4edb936a004c4ba421c455f44964e7.jpg";